import { PrismicRichText } from '@prismicio/react';
import { useRef } from 'react';
import { useIntl } from 'react-intl';
import Link from 'next-translate-routes/link';
import Slider, { Settings } from 'react-slick';

import { Tag } from '@prismic/gqlTypes/prismicTypes';
import { BlogPostFragment } from '@prismic/gqlTypes/prismicOperations';

import { linkResolver } from '@prismic/prismic-config';

import { commonMessages } from '../../../intl';

import * as S from './styles';

interface IProps {
  featuresPosts: BlogPostFragment[];
}

export const BlogPostsSlider: React.FC<IProps> = ({ featuresPosts }) => {
  const sliderSettings: Settings = {
    arrows: true,
    autoplay: false,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
  };

  const slider = useRef(null);
  const intl = useIntl();

  return (
    <S.Wrapper className="featured-slider">
      <Slider {...sliderSettings} ref={slider}>
        {featuresPosts &&
          featuresPosts.map((post) => (
            <S.Slide key={post.title}>
              <S.ImageWrapper>
                <S.Image
                  style={{ backgroundImage: `url(${post.image.url})` }}
                />
              </S.ImageWrapper>
              <S.TextWrapper>
                {post.tags &&
                  post.tags.map(({ tag }) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const _tag = tag as Pick<Tag, 'name' | '_linkType'>;

                    return (
                      <S.Tag key={`featured-slide__${_tag.name}`}>
                        {_tag.name}
                      </S.Tag>
                    );
                  })}
                {post.title && (
                  <S.Title>
                    <PrismicRichText field={post.title} />
                  </S.Title>
                )}
                {post.preview_description && (
                  <S.Description>
                    <PrismicRichText field={post.preview_description} />
                  </S.Description>
                )}
                <Link href={linkResolver(post)} passHref>
                  <a>
                    <S.ReadButton fullWidth>
                      {intl.formatMessage(commonMessages.readOn)}
                    </S.ReadButton>
                  </a>
                </Link>
              </S.TextWrapper>
            </S.Slide>
          ))}
      </Slider>
    </S.Wrapper>
  );
};
